import React from 'react'
import EditForm, { defaultPropTypes, connectEditForm } from '../common/EditForm'
import LabeledTextField from '../common/LabeledTextField'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import actions from '../../actions/SBCConfigurations'
import CheckboxField from '../common/CheckboxField'
import LgcCustomerOptions from './LgcCustomerOptions'

export class SbcConfigurationEdit extends Component {
  static propTypes = defaultPropTypes

  get id() {
    return this.props.params.id
  }

  handleChange = (attributes) => {
    if (!attributes.lgc_customer) {
      // eslint-disable-next-line no-param-reassign
      attributes.lgc_customer_options = []
    }
  }

  render() {
    return (
      <EditForm {...this.props} id={this.id} handleChange={this.handleChange}>
        <LabeledTextField
          key="source_identifier"
          name="source_identifier"
          label="Source ID"
        />

        <CheckboxField
          key="lgc_customer"
          name="lgc_customer"
          label="Large Group Custom"
        />

        <LgcCustomerOptions
          key="lgc_customer_options"
          name="lgc_customer_options"
        />
      </EditForm>
    )
  }
}

export default connectEditForm(withRouter(SbcConfigurationEdit),
  'SbcConfiguration',
  'sbc_configurations',
  actions,
  '/configurations')

